import { create } from 'zustand';

// Define the interface for the store's state
interface NotificationStoreState {
    notificationCount: number;
    setNotificationCount: (count: number) => void;
    clearNotificationCount: () => void;
}

export const useNotificationStore = create<NotificationStoreState>(
    set => ({
        notificationCount: 0,
        
        setNotificationCount: (count: number) =>
            set({ notificationCount: count }),
        
        clearNotificationCount: () =>
            set({ notificationCount: 0 }),
    }),
);
